import React, {useEffect} from 'react'
import {Grid, TextField} from '@material-ui/core';
import '../App.css';
import { Transition } from 'react-transition-group';
import { useStyles } from '../Components/useStyles';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import 'date-fns';

export default function TwinTripletInfoPage({showTTIPage, twinLable, setTripletsID, tripletID, twinID, setTwinsID, firstTimeInTwinPage,
    setTwinFirstName, setTwinLastName, setTwinDOB, twinFirstName, twinLastName, twinDOB, setTripletFirstName, setTripletLastName, 
    setTripletDOB, tripletFirstName, tripletLastName, tripletDOB, setIsInvalidDOB}) {
        
    const classes = useStyles();
    const [requiredInput, setRequiredInput] = React.useState(false);  
    
    const regexpName = /^$|^[-A-Za-z ]+$/;

    let firstName = twinFirstName;
    let lastName = twinLastName;

    
    useEffect(() => {
        requiredCheck();
     },[twinFirstName, twinLastName, twinDOB]);

     useEffect(() =>{
        setIsInvalidDOB(false);
     },[]);


    function handleTwinDateChange(dob) {
        if(dob !== null && !isNaN(dob.getTime())) {
            setTwinDOB(dob.toDateString());
        }
        else if(dob === null)
            setTwinDOB(null);
    }

    function handleTripletDateChange(dob) {
        if(dob === null || !isNaN(dob.getTime()))
            setTripletDOB(dob);
    }

    function requiredCheck() {
        if((twinID != null && twinID != '') || (twinFirstName != null && twinFirstName != '') || twinLastName != null && twinLastName != '' || (twinDOB != null && twinDOB != '')) {
            setRequiredInput(true);
        } else {
            setRequiredInput(false);
        }
    }

    function validateDOB(date) {
        if((new Date(date)) == "Invalid Date" && date != "mm/dd/yyyy") {
            setIsInvalidDOB(true);
        } else {
            setIsInvalidDOB(false);
        }
    }

    const duration = 700;

    const defaultStyle = {
    transition: `opacity ${duration}ms ease-in-out`,
    opacity: 0,
    }

    const transitionStyles = {
    entering: { opacity: 1 },
    entered:  { opacity: 1 },
    exiting:  { opacity: 0 },
    exited:  { opacity: 0 },
    };
    return (
        <>
            <Transition in={showTTIPage} timeout={duration} appear={firstTimeInTwinPage}>
            {state => (
            <div style={{
                ...defaultStyle,
                ...transitionStyles[state]
            }}> 
                <h1 className='Title2-settings'>Are you applying for a student who is a twin? If not, click next.</h1>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                            <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    <TextField id="txt_twinstudentid" label={"Twin's " + twinLable} defaultValue={twinID === 0 || twinID === null ? null : twinID} 
                                        className={classes.FulltextField} margin="normal" variant="outlined" fullWidth={true} onBlur={event=>setTwinsID(event.target.value)} inputProps={{maxLength: 9}}
                                    /> 
                                </Grid>
                                <Grid item xs={6}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>           
                                        <KeyboardDatePicker  required = {requiredInput} variant="inline" format="MM/dd/yyyy" margin="normal" id="date_twinDOB" label="Twin's Date of Birth"
                                            value={twinDOB} fullWidth={true} KeyboardButtonProps={{ 'aria-label': 'change date',}} emptyLabel="mm/dd/yyyy" maxDateMessage={"Twin's Birthdate can not be in the future"}
                                            className={classes.FulltextField} inputVariant="outlined" disableFuture={true} onChange={handleTwinDateChange} onBlur={event=>validateDOB(event.target.value)}
                                    />
                                    </MuiPickersUtilsProvider>  
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    <TextField required = {requiredInput} id="txt_twinfirstname" label={"Twin's first name"} defaultValue={twinFirstName} error={!regexpName.test(firstName)} helperText={!regexpName.test(firstName) ? 'Please use english letters' : ''}
                                        className={classes.FulltextField} margin="normal" variant="outlined" fullWidth={true} onBlur={event=>setTwinFirstName(event.target.value)}
                                    /> 
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField required = {requiredInput} id="txt_twinlastname" label={"Twin's last name"} defaultValue={twinLastName} error={!regexpName.test(lastName)} helperText={!regexpName.test(lastName) ? 'Please use english letters' : ''}
                                        className={classes.FulltextField} margin="normal" variant="outlined" fullWidth={true} onBlur={event=>setTwinLastName(event.target.value)}
                                    /> 
                                </Grid>
                            </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        &nbsp;
                    </Grid>
                </Grid>
             </div>)}
            </Transition>  
        </>
    );
}